import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setNodes } from '~/reducers';
import { myStore } from '~/App';

/**
 * Hook personalizado para atualizar nós sem depender do useFlowFunctions
 * Usado nos componentes de nós customizados para atualizações de dados
 */
export const useNodeUpdate = () => {
    const dispatch = useDispatch();

    const updateNode = useCallback((nodeId, updatedData) => {
        const currentNodes = myStore.getState().nodes.nodes;
        
        const updatedNodes = currentNodes.map(node => {
            if (node.id === nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        ...updatedData
                    }
                };
            }
            return node;
        });
        
        dispatch(setNodes(updatedNodes));
    }, [dispatch]);

    // Compatibilidade com a API do onNodesChange para facilitar migração
    const onNodesChange = useCallback((changes) => {
        const currentNodes = myStore.getState().nodes.nodes;
        let updatedNodes = [...currentNodes];
        
        changes.forEach(change => {
            if (change.type === 'update') {
                updatedNodes = updatedNodes.map(node => {
                    if (node.id === change.id) {
                        return {
                            ...node,
                            data: {
                                ...node.data,
                                ...change.data
                            }
                        };
                    }
                    return node;
                });
            }
            // Outras operações como 'remove', 'add', etc. podem ser implementadas aqui se necessário
        });
        
        dispatch(setNodes(updatedNodes));
    }, [dispatch]);

    return { updateNode, onNodesChange };
};